import { FC } from "react";
import { Box, Stack } from "@mui/material";
import {
  FilterGroupNode,
  ResourceExplorerFilterProvider,
  ResourceExplorerPossibleFilterV2,
} from "@/services/cloudchipr.api";
import { ProviderIcon } from "@/components/common/ProviderIcon";
import { isTreeNodeFilterGroup } from "@/components/pages/common/filters-tree/utils/helpers/isTreeNodeWithIdFilterGroup";
import { FilterTreeDisabledItem } from "@/components/pages/common/filters-tree/filters-disabled-view/components/FilterTreeDisabledItem";
import { FilterTreeDisabledGroup } from "@/components/pages/common/filters-tree/filters-disabled-view/components/FilterTreeDisabledGroup";

interface ProviderFilterDisabledCardProps {
  filters: FilterGroupNode;
  filterProvider: ResourceExplorerFilterProvider;
  possibleFilters: ResourceExplorerPossibleFilterV2[];
}

export const ProviderFilterTreeDisabledCard: FC<
  ProviderFilterDisabledCardProps
> = ({ filterProvider, possibleFilters, filters }) => {
  return (
    <Stack direction="row" borderRadius={2} bgcolor="grey.50" overflow="hidden">
      <Box p={1} bgcolor="grey.100">
        <ProviderIcon provider={filterProvider} />
      </Box>

      <Stack flex={1} overflow="hidden" p={1} spacing={1}>
        <Stack spacing={1} flex={1}>
          {filters.items.map((filter, index) => {
            return (
              <Stack key={index} direction="row" alignItems="center">
                {isTreeNodeFilterGroup(filter) ? (
                  <FilterTreeDisabledGroup
                    index={index}
                    filters={filter}
                    parentOperator={filters.operator}
                    possibleFilters={possibleFilters}
                  />
                ) : (
                  <FilterTreeDisabledItem
                    index={index}
                    filter={filter}
                    parentOperator={filters.operator}
                    possibleFilters={possibleFilters}
                  />
                )}
              </Stack>
            );
          })}
        </Stack>
      </Stack>
    </Stack>
  );
};
